import { Variant } from '../../../Variant/Variant';
import styles from './ClassicQuiz.module.css';
import { motion } from 'framer-motion';

export const ClassicQuiz = ({
  variants,
  isStateCorrectVar,
  questionAnimation,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={styles.variantsContainer}
    >
      {variants?.map((item, i) => (
        <motion.div
          key={item.coment + String(i)}
          initial={{
            scale: 0,
            opacity: 0,
            originX: 0,
            originY: 'center',
          }}
          animate={{
            scale: [0, 1.1, 1],
            opacity: 1,
            originX: 0,
            originY: 'center',
          }}
          transition={{
            duration: 1,
            delay: i * 0.8 + questionAnimation,
          }}
        >
          <motion.div
            initial={{
              scale: 1,
              opacity: 1,
            }}
            animate={{
              scale: isStateCorrectVar && item.correct ? 1.05 : 1,
              opacity: isStateCorrectVar ? (item.correct ? 1 : 0.5) : 1,
            }}
            transition={{
              duration: 0.5,
              delay: 1,
            }}
          >
            <Variant
              item={item}
              index={i}
              aciveAmimate={isStateCorrectVar && item.correct}
            />
          </motion.div>
        </motion.div>
      ))}
    </motion.div>
  );
};
